import { joinClasses } from '../../primitives/fieldClassSlots';
import { useLayoutDerived } from '../LayoutDerivedContext';
import { layoutInlineStyle } from '../layoutInlineStyle';
import type { DisplayNode } from '../types';
import { lookupDerivedNumeric } from '../whenClause';

export function DisplayBlock({ node }: { node: DisplayNode }) {
  const derived = useLayoutDerived();
  const n = lookupDerivedNumeric(derived, node.ref);

  return (
    <div
      className={joinClasses('text-sm tabular-nums', node.className)}
      style={layoutInlineStyle(node.style)}
    >
      {node.label != null && node.label !== '' ? (
        <>
          <span>{node.label}</span>
          <span className='mx-1 text-muted-foreground'>:</span>
        </>
      ) : null}
      <span className='font-medium'>{n}</span>
    </div>
  );
}
